import ereq from '../../../../util/ereq.js';

import config_ext from '../../../config_ext.js';

let E: Record<string, any> = {}
export default E

let prefix = config_ext.back.app.url;
export let API_BASE_URL = prefix;

let _get_token: (() => Promise<string>) | null = null

export let set_token_getter = (fn: () => Promise<string>) => {
  _get_token = fn
}

let api_get = async (path: string, qs?: Record<string, any>) => {
  if (!_get_token)
    throw new Error('no session')
  let token = await _get_token()
  let res = await ereq.get(prefix + path,
    {qs, no_print: true, headers: ereq.auth_hdr(token)})
  if (res.err)
    return res
  return res.data
}

let api_get_pub = async (path: string, qs?: Record<string, any>) => {
  let res = await ereq.get(prefix + path, {qs, no_print: true})
  if (res.err)
    return res
  return res.data
}

let api_post = async (path: string, data?: any) => {
  if (!_get_token)
    throw new Error('no session')
  let token = await _get_token()
  let res = await ereq.post(prefix + path,
    {data, no_print: true, headers: ereq.auth_hdr(token)})
  if (res.err)
    return res
  return res.data
}

let api_upload = async (path: string, data: Record<string, any>) => {
  if (!_get_token)
    throw new Error('no session')
  let token = await _get_token()
  let res = await ereq.post_upload(prefix + path,
    {data, no_print: true, headers: ereq.auth_hdr(token)})
  if (res.err)
    return res
  return res.data
}



E.user_get = async (email: string) => {
  return api_get('/private/user/get.json', {email})
}

E.user_init = async (email: string) => {
  return api_get('/pub/user/init_auth0.json', {insert: true, email})
}

E.user_email_resend = async (email: string) => {
  if (!_get_token)
    throw new Error('no session')
  let token = await _get_token()
  let res = await ereq.get(prefix + '/pub/user/email_resend.json',
    {qs: {email, token}, no_print: true, headers: ereq.auth_hdr(token)})
  if (res.err)
    return res
  return res.data
}

E.user_set = async (key: string, v: any) => {
  return api_get('/private/user/set.json', {key, v: String(v)})
}

E.org_get = async () => {
  return api_get('/private/org/get.json')
}

E.org_set = async (key: string, v: any) => {
  return api_get('/private/org/set.json', {key, v: String(v)})
}



E.bprofile_get = async () => {
  return api_get('/private/bprofile/get.json')
}

E.bprofile_set = async (data: any) => {
  return api_post('/private/bprofile/set.json', data)
}

E.bprofile_account_get = async () => {
  return api_get('/private/bprofile/account/get.json')
}

E.bprofile_account_insert = async () => {
  return api_post('/private/bprofile/account/insert.json', {})
}

E.bprofile_account_deposit = async (amount: number) => {
  return api_post('/private/bprofile/account/deposit.json', {amount})
}



E.basset_list = async () => {
  return api_get('/private/basset/list.json')
}

E.basset_insert = async (body: FormData | any) => {
  if (body instanceof FormData) {
    let data: Record<string, any> = {}
    body.forEach((v, k) => { data[k] = v })
    return api_upload('/private/basset/insert.json', data)
  }
  return api_post('/private/basset/insert.json', body)
}

E.org_logo_from_url = async (url: string) => {
  return api_post('/private/org/logo_from_url.json', {url})
}

E.camp_cat_get = async () => {
  return api_get_pub('/pub/camp/cat_get.json')
}

E.org_logo_upload = async (body: FormData | any) => {
  if (body instanceof FormData) {
    let data: Record<string, any> = {}
    body.forEach((v, k) => { data[k] = v })
    return api_upload('/private/org/logo_upload.json', data)
  }
  return api_post('/private/org/logo_upload.json', body)
}

E.basset_delete = async (id: string) => {
  return api_post('/private/basset/delete.json', {id})
}

E.basset_camp_list = async (id: string) => {
  return api_get('/private/basset/camp_list.json', {id})
}



E.campaign_list = async () => {
  return api_get('/private/campaign/list.json')
}

E.campaign_get = async (id: string) => {
  return api_get('/private/campaign/get.json', {id})
}

E.campaign_create = async (data: any) => {
  return api_post('/private/campaign/create.json', data)
}

E.campaign_update = async (data: any) => {
  return api_post('/private/campaign/update.json', data)
}

E.campaign_delete = async (id: string) => {
  return api_post('/private/campaign/delete.json', {id})
}

E.campaign_asset_list = async (id: string) => {
  return api_get('/private/campaign/asset_list.json', {id})
}



E.vcamp_list = async (params?: {campaign_id?: string, video_id?: string}) => {
  let qs: Record<string, string> = {}
  if (params?.campaign_id)
    qs.campaign_id = params.campaign_id
  if (params?.video_id)
    qs.video_id = params.video_id
  return api_get('/private/vcamp/list.json', qs)
}

E.vcamp_get = async (id: string) => {
  return api_get('/private/vcamp/get.json', {id})
}

E.vcamp_insert = async (data: any)=>{
  return api_post('/private/vcamp/insert.json', data)
}

E.vcamp_analyze = async (data: any) => {
  return api_post('/private/vcamp/analyze.json', data)
}

E.vcamp_select_placement = async (data: any) => {
  return api_post('/private/vcamp/select_placement.json', data)
}

E.vcamp_process = async (data: any) => {
  return api_post('/private/vcamp/process.json', data)
}

E.vcamp_publish = async (data: {id: string, url: string}) => {
  return api_post('/private/vcamp/publish.json', data)
}

E.vcamp_delete = async (id: string) => {
  return api_post('/private/vcamp/delete.json', {id})
}



E.video_list = async () => {
  return api_get('/private/video/list.json')
}

E.video_get = async (id: string) => {
  return api_get('/private/video/get.json', {id})
}

E.video_insert = async (data: any) => {
  return api_post('/private/video/insert.json', data)
}

E.video_upload = async (body: FormData | any) => {
  if (body instanceof FormData) {
    let data: Record<string, any> = {}
    body.forEach((v, k) => { data[k] = v })
    return api_upload('/private/video/upload.json', data)
  }
  return api_post('/private/video/upload.json', body)
}

E.video_update = async (data: any) => {
  return api_post('/private/video/update.json', data)
}

E.video_delete = async (id: string) => {
  return api_post('/private/video/delete.json', {id})
}



E.cprofile_get = async () => {
  return api_get('/private/cprofile/get.json')
}

E.cprofile_set = async (data: any) => {
  return api_post('/private/cprofile/set.json', data)
}

E.cprofile_rank_update = async () => {
  return api_get('/private/cprofile/rank_update.json')
}



E.social_connections = async () => {
  return api_get('/private/social/connections.json')
}

E.social_auth_url = async (platform: string) => {
  return api_get('/private/social/auth_url.json', {platform})
}

E.social_disconnect = async (data: any) => {
  return api_post('/private/social/disconnect.json', data)
}

E.social_recent_posts = async (social_id: string) => {
  return api_get('/private/social/recent_posts.json', {social_id})
}

E.social_publish = async (data: any) => {
  return api_post('/private/social/publish.json', data)
}

E.creator_status_get = async () => {
  return api_get('/private/creator/status.json')
}



E.creator_camp_list = async (params?: {video_id?: string, any_country?: boolean}) => {
  let qs: Record<string, string> = {}
  if (params?.video_id)
    qs.video_id = params.video_id
  if (params?.any_country)
    qs.any_country = '1'
  return api_get('/private/creator_camp/list.json', qs)
}



E.campaign_browse = async (params?: {category?: string}) => {
  let qs: Record<string, string> = {}
  if (params?.category)
    qs.category = params.category
  return api_get('/private/campaign/browse.json', qs)
}